import { z } from "zod";
import { timestampSchema } from "./timestamp";

/**
 * Odbyta rozmowa Money Talk — jeden doc per tydzień,
 * docId = weekKey (YYYY-MM-DD poniedziałku). Istnienie doca = rozmowa odbyta.
 * Niemutowalny po create (rules), delete tylko parent.
 */
export const moneyTalkSchema = z.object({
  weekKey: z.string(),
  /** Snapshot pytania, przy którym rodzina kliknęła „OK, pogadamy". */
  question: z.string().min(1).max(300),
  markedBy: z.string(),
  markedAt: timestampSchema,
});
export type MoneyTalk = z.infer<typeof moneyTalkSchema>;
